import {Toast, ToastType} from '@sportcast/ui-react';
import {useEffect, useState} from 'react';
import {useTranslation} from 'react-i18next';
import './Message.scss';

export type MessageProps = {
    messageId?: string,
    message?: string,
    autoClose?: boolean,
    type: ToastType,
    autoCloseDuration?: number,
    i18nMessage?: string
};

const Message = (props: MessageProps) => {
    const [t] = useTranslation();
    const [showMessage, setShowMessage] = useState(true);

    useEffect(() => {
        setShowMessage(true);
    }, [props.messageId]);

    const handleClose = () => {
        setShowMessage(false);
    };

    return (
        <div className="message">
            <Toast
                id={props.messageId}
                message={props.i18nMessage ? t<string>(props.i18nMessage) : props.message}
                show={showMessage}
                variant={props.type}
                onClose={handleClose}
                autohide={props.autoClose === true || props.type !== ToastType.DEFAULT}
                delay={props.type === ToastType.ERROR ? 10000 : 3000}
            />
        </div>
    );
};

export default Message;

